import { nanoid } from 'nanoid';
import { useTranslation } from 'react-i18next';
import { useRecoilCallback } from 'recoil';
import {
  notificationAppender,
  notificationCollection,
  NotificationDetails,
} from '../../store/notification.state';

function useNotification(): [
  addNotification: (
    notification: Omit<NotificationDetails, 'id'>,
  ) => Promise<void>,
  removeNotification: (notificationId: string) => Promise<void>,
] {
  const { t } = useTranslation('app');

  const removeNotification = useRecoilCallback(
    ({ snapshot, set }) =>
      async (notificationId: string) => {
        const current = await snapshot.getPromise(notificationCollection);
        set(
          notificationCollection,
          current.filter(n => n.id !== notificationId),
        );
      },
  );

  const addNotification = useRecoilCallback(
    ({ snapshot, set }) =>
      async (notification: Omit<NotificationDetails, 'id'>) => {
        const id = nanoid();
        set(notificationAppender, {
          id,
          ...notification,
        });
        if (notification.autoDismiss) {
          setTimeout(() => {
            removeNotification(id);
          }, 5000);
        }
      },
  );

  return [addNotification, removeNotification];
}

export default useNotification;
